export const mockUserStats = {
  kpi: {
    active_rentals: 2,
    total_spent: 125500,
    upcoming_events: 1,
    loyalty_points: 450
  },
  recent_activity: [
    {
      id: 1,
      action: "Rental Request",
      entity: "Premium White Chairs (50)",
      time: "2 hours ago",
      status: "pending"
    },
    {
      id: 2,
      action: "Invoice Paid",
      entity: "INV-2026-001",
      time: "Yesterday",
      status: "success"
    },
    {
      id: 3,
      action: "Order Completed",
      entity: "Garden Party Setup",
      time: "3 days ago",
      status: "completed"
    }
  ],
  upcoming_rentals: [
    {
      id: 101,
      title: "Wedding Reception Set",
      date: "March 15, 2026",
      status: "Confirmed",
      color: "#62397f"
    }
  ]
};

export const mockUserRentals = [
  {
    id: "INV-2026-001",
    items: "50 Chairs, 10 Tables, Premium Linens",
    orderDate: "2026-03-01",
    eventDate: "2026-03-15",
    total: 85000,
    status: "Confirmed",
    paymentStatus: "Paid"
  },
  {
    id: "INV-2026-002",
    items: "Outdoor Lighting, Sound System",
    orderDate: "2026-03-02",
    eventDate: "2026-03-20",
    total: 40500,
    status: "Pending",
    paymentStatus: "Partial"
  }
];

export const mockUserProfile = {
  fullName: "Oluwaseun Adeyemi",
  email: "olu.adeyemi@example.com",
  phone: "+234 802 123 4567",
  address: "15 Adeniran Ogunsanya St, Surulere, Lagos",
  joinDate: "January 2026"
};
